import * as yup from 'yup';

export const eventSchema = yup.object({
  name: yup.string().required('Event name is required'),
  image: yup.object({
    file_name: yup.string().required(),
    ext: yup.string().required(),
    width: yup.number().optional(),
    sizes: yup.array().of(yup.number()).optional(),
  }).required('A photo is required').typeError('A photo is required'),
});

export function newEvent() {
  return {
    name: '',
    image: null,
  };
}
